import React from 'react'
import { useSelectBehaviour } from 'legacy/dash-components/select/utils/select.hooks'
import {
  DashSimpleSelect,
  type DashSimpleSelectProps,
} from 'legacy/dash-blocks/dash-simple-select/DashSimpleSelect'

export const SimpleSelect = <TValue extends string | number | null | undefined = string>(
  props: DashSimpleSelectProps<TValue>
) => {
  const behaviour = useSelectBehaviour()

  return <DashSimpleSelect<TValue> {...behaviour} {...props} />
}
